module.exports = __webpack_public_path__ + "img/1._Bergungsgruppe_EGS.1a2353e5.svg";